import type { CreateRequestPayload, RequestItem } from "../../api/requests";
import { createRequest } from "../../api/requests";

export interface BatchCreateResult {
  succeeded: RequestItem[];
  failed: unknown[];
}

export const createRequestsSequentially = async (
  payloads: CreateRequestPayload[]
): Promise<BatchCreateResult> => {
  const succeeded: RequestItem[] = [];
  const failed: unknown[] = [];

  for (const payload of payloads) {
    try {
      const item = await createRequest(payload);
      succeeded.push(item);
    } catch (err) {
      failed.push(err);
    }
  }

  return { succeeded, failed };
};

export interface BatchCreateNotification {
  message: string;
  variant: "success" | "error";
}

export const getBatchCreateNotification = (
  result: BatchCreateResult,
  total: number
): BatchCreateNotification | null => {
  const { succeeded, failed } = result;

  if (!succeeded.length) return null;

  if (total > 1 && !failed.length) {
    return {
      message: "Все заявки успешно созданы",
      variant: "success",
    };
  }

  if (total > 1 && failed.length) {
    return {
      message: "Часть заявок создана, по остальным возникла ошибка",
      variant: "success",
    };
  }

  return {
    message: "Заявка успешно создана",
    variant: "success",
  };
};
